import type { NavigationItem, NavigationSection } from '../../generated/graphql'

export const resolveType = (obj: NavigationItem | NavigationSection) => {
  /**
   * Resolve 'NavigationElement' union.
   */
  if ('items' in obj) {
    return 'NavigationSection'
  }
  return 'NavigationItem'
}
